<script setup lang="ts">
import type { Component } from "vue";
import type { ContainerProps } from "@nuxt/ui";

withDefaults(defineProps<{ is?: string | Component; ui?: ContainerProps["ui"] }>(), { is: "section" });
</script>

<template>
  <component :is class="flex flex-col pb-4 -mb-4">
    <UContainer class="flex flex-col grow" :ui>
      <slot />
    </UContainer>
  </component>
</template>
